'use client'

import type { DestinationV1PageBlokProps } from '@7f-ui/storyblok/schema/content-types/destination-page'
import type { NexperienceSearchItemFragment } from '@data-access/lib/gql/experience/documents'
import { ExperienceTeaser } from '@feat/feat-destinations/teaser'
import { BeachChairsTeaser } from '@feat/feat-destinations-v1/beach-chairs-teaser'
import { TopAccommodations } from '@feat/feat-destinations-v1/top-accommodations'
import type { ReactNode } from 'react'
import type { DestinationFragment } from 'src/lib/backend/documents/destinations'

import { DestinationHeader } from './destination-header'

type DestinationV1ClientProps = {
  destination: DestinationFragment
  topExperiences: NexperienceSearchItemFragment[]
  destinationBlok: DestinationV1PageBlokProps
  block1Content?: ReactNode
  block2Content?: ReactNode
  block3Content?: ReactNode
  block4Content?: ReactNode
}

export function DestinationV1Client({
  destination,
  topExperiences,
  destinationBlok,
  block1Content,
  block2Content,
  block3Content,
  block4Content,
}: DestinationV1ClientProps) {
  return (
    <>
      <DestinationHeader destination={destination} destinationBlok={destinationBlok} />
      <div className="bleed-container mt-12 gap-y-12 md:mt-16 md:gap-y-16">
        {block4Content}

        {destination.areaPolygon?.coordinates && (
          <div className="bleed-container full-bleed scroll-m-8" id="unterkuenfte">
            <TopAccommodations
              coordinates={destination.areaPolygon.coordinates}
              name={destination.name}
            />
          </div>
        )}

        {block1Content}

        <div className="bleed-container full-bleed scroll-m-8" id="erlebnisse">
          <ExperienceTeaser destination={destination} topExperiences={topExperiences} />
        </div>

        {block2Content}

        <div className="full-bleed" id="strandkoerbe">
          <BeachChairsTeaser destination={destination} />
        </div>

        {block3Content}
      </div>
    </>
  )
}
